<template>
	<div class="md-layout">
		<chat-card
			v-bind="{ channelSid: entity.twilioChannelSid, clientId: entity.userId, clientName: entity.userName }" :sync="entity">
		</chat-card>
	</div>
</template>

<script>
	import Chat from "@/models/chat.model.vue";
	import EntityCard from "@/components/Espresso/EntityCard.vue";
	import ChatCard from "@/components/Espresso/ChatCard.vue";

	export default {
		components: {
			EntityCard,
			ChatCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Chat.getSchema(),
			}
		},
		methods: {
			async readEntity(entityId) {
				const response = await Chat.getInfo(entityId);
				this.entity = response;

				return response;
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Chat.updateInfo(dataToUpdate);
			},
		},
		created() {
			this.readEntity(this.entity.id);
		},
	};
</script>
